// NPM
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Stores
import { useUserStore } from '@/stores/user';
import { useReferrals } from '@/api/referrals/use-referrals';
import { useHasPendingAction } from '@/composables/useHasPendingAction';
import { useRoute } from 'vue-router';

export function useNavigationItems() {
  // Stores
  const userStore = useUserStore();
  const route = useRoute();
  const disablePendingActionQueries =
    route.name === 'helpee-report-feedback-view' ||
    route.name === 'helpee-campaigns';
  const { data: referral } = useReferrals(disablePendingActionQueries);
  const { hasChallengeAction, hasEventAction, hasUgcAction, hasRelationAction } =
    useHasPendingAction(disablePendingActionQueries);

  // Plugins
  const { t } = useI18n({ useScope: 'global' });

  // Data
  const navigationItems = computed(() => {
    return [
      {
        icon: 'users',
        name: 'Relations',
        to: {
          name: 'relations-empty-state',
        },
        enabled: true,
        hasAction: hasRelationAction.value,
      },
      {
        icon: 'star',
        name: 'Challenges',
        to: {
          name: 'available-challenges',
        },
        enabled: userStore.user?.organization?.challengeEnabled,
        hasAction: hasChallengeAction.value,
      },
      {
        icon: 'calendar',
        name: t('generic.events'),
        to: {
          name: 'available-events',
        },
        enabled: true,
        hasAction: hasEventAction.value,
      },
      {
        icon: 'phone-01',
        name: t('generic.ugcs'),
        to: {
          name: 'available-ugcs',
        },
        enabled: true,
        hasAction: hasUgcAction.value,
      },
      {
        icon: 'gift',
        name: t('generic.rewards'),
        to: {
          name: 'rewards',
        },
        enabled: userStore.user?.organization?.rewardEnabled,
        hasAction: false,
      },
      {
        icon: 'heart-hand',
        name: t('referral.navigation'),
        to: {
          name: 'referral',
        },
        enabled: referral.value?.shouldDisplayReferralCampaign,
        hasAction: false,
      },
      {
        icon: 'link',
        name: t('generic.sharingPage'),
        to: {
          name: 'sharing',
        },
        enabled: userStore.sharingPageEnabled,
        hasAction: false,
      },
      {
        icon: 'toggle',
        name: t('generic.helperStatus'),
        to: {
          name: 'helper-status',
        },
        enabled: true,
        hasAction: false,
      },
    ];
  });

  return {
    navigationItems,
  };
}
